import React from 'react';

import ErrorMessage from '../components/ErrorMessage';

const PleaseSignInPage = () => {
	return (
		<ErrorMessage message = "Please Sign in to use this service" />
	);
};

export default PleaseSignInPage;